import React, { useState, useEffect } from 'react';
import { Dialog } from '@headlessui/react';
import { FaBars } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/service' },
  { label: 'Products', path: '/products' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const getIsActive = (itemPath, currentPath) => {
  if (itemPath === '/') return currentPath === '/';
  return currentPath.startsWith(itemPath);
};

const Navbar = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 0);
    };

    handleScroll(); // initialize on load

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`w-full z-50 flex justify-center px-4 transition-all duration-300 ease-in-out
        ${hasScrolled ? 'fixed top-0' : 'relative'}`
      }
    >
      <div
        className={`w-full flex items-center justify-between px-6 py-4 transition-all duration-300
        ${hasScrolled ? 'bg-white shadow-lg rounded-2xl mt-2' : ''}`}
      >
        {/* Logo */}
        <div className="flex-1">
          <Link to="/" className="flex items-center space-x-2">
            <img src="images/WEB_Logo.jpg" alt="Logo" className="h-14" />
          </Link>
        </div>

        {/* Center Nav Items - Hidden on Mobile */}
        <div className="flex-1 justify-center items-center hidden lg:flex">
          <nav className="flex items-center space-x-4 text-sm font-medium text-primary">
            {navItems.map(({ label, path }, idx) => (
              <Link
                key={idx}
                to={path}
                className={`px-3 py-2 rounded-full whitespace-nowrap transition duration-300 text-base ${getIsActive(path, location.pathname)
                    ? 'bg-primary text-white'
                    : 'hover:text-secondary'
                  }`}
              >
                {label.toUpperCase()}
              </Link>
            ))}
          </nav>
        </div>

        {/* CTA - Desktop Only */}
        <div className="flex-1 hidden lg:flex justify-end items-center space-x-3">
          <a
            href="/company-profile.pdf"
            download
            className="px-6 py-2 rounded-full bg-primary text-white font-semibold text-base hover:bg-secondary transition"
          >
            COMPANY PROFILE
          </a>
        </div>

        {/* Mobile Drawer Button */}
        <div className="lg:hidden">
          <button
            className="bg-primary p-3 rounded-full"
            onClick={() => setIsMobileOpen(true)}
          >
            <FaBars className="text-white text-xl" />
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <Dialog open={isMobileOpen} onClose={() => setIsMobileOpen(false)} className="lg:hidden relative z-50">
        <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
        <Dialog.Panel className="fixed right-0 top-0 h-full w-64 bg-white p-6 shadow-lg z-50">
          <div className="flex justify-between items-center mb-6">
            <img src="images/WEB_Logo.jpg" alt="Logo" className="h-10" />
            <button onClick={() => setIsMobileOpen(false)} className="text-gray-700 text-xl font-bold">
              ✕
            </button>
          </div>
          <nav className="flex flex-col space-y-4 text-base font-medium text-gray-800">
            {navItems.map(({ label, path }, idx) => (
              <Link
                key={idx}
                to={path}
                onClick={() => setIsMobileOpen(false)}
                className="hover:text-primary transition"
              >
                {label}
              </Link>
            ))}
            <div className="pt-4 mt-4 border-t">
              <a
                href="/company-profile.pdf"
                download
                className="w-full bg-primary text-white py-2 px-2 rounded text-center hover:bg-secondary transition text-base font-semibold block"
              >
                COMPANY PROFILE
              </a>
            </div>
          </nav>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
};

export default Navbar;
